var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorthStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.25C12.5 0.835786 12.1642 0.5 11.75 0.5C11.3358 0.5 11 0.835786 11 1.25V9.93931L6.44671 5.38603C6.15382 5.09313 5.67894 5.09313 5.38605 5.38603C5.09316 5.67892 5.09316 6.15379 5.38605 6.44669L9.93937 11H1.25C0.835787 11 0.5 11.3358 0.5 11.75C0.5 12.1642 0.835787 12.5 1.25 12.5H9.93936L5.38606 17.0533C5.09316 17.3462 5.09316 17.8211 5.38606 18.114C5.67895 18.4069 6.15382 18.4069 6.44672 18.114L11 13.5607V22.25C11 22.6642 11.3358 23 11.75 23C12.1642 23 12.5 22.6642 12.5 22.25V13.5606L17.0533 18.1139C17.3462 18.4068 17.8211 18.4068 18.114 18.1139C18.4069 17.8211 18.4069 17.3462 18.114 17.0533L13.5607 12.5H22.25C22.6642 12.5 23 12.1642 23 11.75C23 11.3358 22.6642 11 22.25 11H13.5607L18.114 6.4467C18.4069 6.15381 18.4069 5.67894 18.114 5.38604C17.8211 5.09315 17.3462 5.09315 17.0533 5.38604L12.5 9.93936V1.25Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthStar);
export default __webpack_public_path__ + "static/media/north-star.c07b413e.svg";
export { ForwardRef as ReactComponent };